import React, { useState, useEffect, useRef } from "react";
import { Button } from "primereact/button";
import { getSocket } from '../context/socket'; // adjust the path if needed
import { useAuth } from "../context/AuthContext";
import CustomToast from "./CustomToast";
import { Form } from 'react-bootstrap';
import { InputText } from "primereact/inputtext";

const MAX_TOTAL_SIZE = 15 * 1024 * 1024; // 15 MB

const CardSectionPopup = ({ onCancel, togglePopup, cardId, boardId }) => {
    const toastRef = useRef(null);
    const [selectedType, setSelectedType] = useState('');
    const [linkInputs, setLinkInputs] = useState([{ url: '', title: '' }]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const { userId } = useAuth();
    const socket = getSocket();


    const showMessage = (severity, detail) => {
        const summary = severity.charAt(0).toUpperCase() + severity.slice(1);
        toastRef.current.show(severity, summary, detail);
    };

    const handleLinkChange = (index, field, value) => {
        const updatedLinks = [...linkInputs];
        updatedLinks[index][field] = value;
        setLinkInputs(updatedLinks);
    };

    const addLinkInput = () => {
        setLinkInputs([...linkInputs, { url: '', title: '' }]);
    };

    const removeLinkInput = (index) => {
        const updatedLinks = linkInputs.filter((_, i) => i !== index);
        setLinkInputs(updatedLinks);
    };


    const handleFileChange = (e) => {
        const files = Array.from(e.target.files || []);
        const totalSize = files.reduce((acc, f) => acc + f.size, 0);
        if (totalSize > MAX_TOTAL_SIZE) {
            showMessage('error', 'Total file size exceeds 15 MB limit.');
            return;
        }
        setSelectedFiles(files);
    };

    const handleInsert = () => {
        if (selectedType === 'link') {
            const validLinks = linkInputs.filter(link => link.url.trim() !== '');
            if (validLinks.length === 0) {
                showMessage('error', 'Warning, please enter at least one valid link.');
                return;
            }

            socket.emit("add_section_links", {
                card_id: cardId,
                links: validLinks,
                user_id: userId
            });
            togglePopup("attachment");
        }

        if (selectedType === 'image' || selectedType === 'file') {
            if (selectedFiles.length === 0) {
                showMessage('warn', 'Warning, Please Insert at least one file/image.');
                return;
            }

            const readerPromises = selectedFiles.map(file => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => {
                        const base64 = reader.result.split(',')[1]; // Remove data:*/*;base64,
                        resolve({
                            filename: file.name,
                            file: base64
                        });
                    };
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                });
            });

            Promise.all(readerPromises)
                .then(fileDataArray => {
                    const eventName = selectedType === 'image' ? 'upload-card-images' : 'upload-card-files';
                    socket.emit(eventName, {
                        files: fileDataArray,
                        card_id: cardId,
                        user_id: userId,
                        cluster_id: null // or boardId, if you treat it as cluster
                    });
                    togglePopup("attachment");
                })
                .catch(error => {
                    console.error("File processing error", error);
                    alert("Error processing files. Please try again.");
                });
        }
    };


    return (
        <div className="popup-box popup-attachment">
            <div className="popup-header">
                Attachment
                <Button icon="pi pi-times" className="p-button-text close-btn" onClick={() => togglePopup("attachment")} />
            </div>
            <div className="popup-body">
                <div className="list-EmpLIst">
                    <div>
                        <div>
                            <p className="mb-1 text-muted"><small>Select type</small></p>
                            <Form.Select
                                aria-label="Default select example"
                                className="mb-2 form-select"
                                value={selectedType}
                                onChange={(e) => setSelectedType(e.target.value)}
                            >
                                <option value="">None</option>
                                <option value="image">Image</option>
                                <option value="file">File</option>
                                <option value="link">Link</option>
                            </Form.Select>
                        </div>

                        {(selectedType === 'image' || selectedType === 'file') && (
                            <div>
                                <p className="mb-1 text-muted"><small>Attach one or more files</small></p>
                                <Form.Control type="file" multiple onChange={handleFileChange} />
                            </div>
                        )}
                        {selectedType === 'link' && (
                            <div>
                                <p className="mb-1 text-muted"><small>Paste one or more links</small></p>
                                {linkInputs.map((input, index) => (
                                    <div key={index} className="mb-2 d-flex align-items-center gap-2">
                                        <InputText
                                            className="w-50"
                                            placeholder="URL"
                                            value={input.url}
                                            onChange={(e) => handleLinkChange(index, 'url', e.target.value)}
                                        />
                                        <InputText
                                            className="w-50"
                                            placeholder="Title"
                                            value={input.title}
                                            onChange={(e) => handleLinkChange(index, 'title', e.target.value)}
                                        />
                                        {linkInputs.length > 1 && (
                                            <Button
                                                icon="pi pi-times"
                                                severity="danger"
                                                className="p-button-text"
                                                onClick={() => removeLinkInput(index)}
                                            />
                                        )}
                                    </div>
                                ))}
                                <Button
                                    icon="pi pi-plus"
                                    label="Add another link"
                                    severity="secondary"
                                    className="p-button-text mb-2"
                                    onClick={addLinkInput}
                                />
                            </div>
                        )}
                    </div>
                </div>
                <Button label="Insert" severity="primary" className="border-0 py-1 px-3 mt-3 me-2" onClick={handleInsert} />
                <Button label="Cancel" severity="secondary" className="border-0 py-1 px-3 mt-3 opacity-75" onClick={() => togglePopup("attachment")} />
            </div>
               <CustomToast ref={toastRef} />
        </div>

    )
}

export default CardSectionPopup
